import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Cart from "../component/Cart";
import CategoryPage from "../component/Category";
import Checkout from "../component/Checkout";
import Payment from "../component/Checkout/payment";
import Failure from "../component/Failure/Failure";
import Footer from "../component/Footer";
import AboutUs from "../component/Footer/aboutUs";
import ContactUs from "../component/Footer/contactUs";
import FAQ from "../component/Footer/faq";
import MyAccount from "../component/Footer/myAccount";
import OrderTracking from "../component/Footer/orderTracking";
import PrivacyPolicy from "../component/Footer/privacyPolicy";
import ReturnPolicy from "../component/Footer/returnPolicy";
import Shippingpolicy from "../component/Footer/Shippingpolicy";
import Termsofservice from "../component/Footer/Termsofservice";
import Header from "../component/Header";
import Home from "../component/Home";
import MultiPayment from "../component/MultiPayment";
import PaymentStatus from "../component/paymentStatus";
import SingleProduct from "../component/SingleProduct";
import Success from "../component/Success/Success";
import ThankYou from "../component/Thank-You/ThankYou";
import Wishlist from "../component/Wishlist";
import { AuthContext } from "../contexts/AuthContext";
import ScrollToTop from "./ScrollToTop";

const AppRouters = () => {
  const isMultiPayment = window.location.pathname === "/multipayment" || window.location.pathname === "/payment-status";
  const show404 = process.env.REACT_APP_SHOW_404 === "true";

  return (
    <Router>
      <ScrollToTop />
      <AuthContext>
        {!isMultiPayment && <Header />}
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/single-product/:id" exact element={<SingleProduct />} />
          <Route path="/cart" exact element={<Cart />} />
          <Route path="/category/:id" exact element={<CategoryPage />} />
          <Route path="/checkout/address" exact element={<Checkout />} />
          <Route path="/checkout/payment" exact element={<Payment />} />
          <Route path="/wishlist" exact element={<Wishlist />} />
          <Route path="/refund-policy" exact element={<ReturnPolicy />} />
          <Route path="/faqs" exact element={<FAQ />} />
          <Route path="/order-tracking" exact element={<OrderTracking />} />
          <Route path="/contact-us" exact element={<ContactUs />} />
          <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
          <Route path="/terms-service" exact element={<Termsofservice />} />
          <Route path="/about-us" exact element={<AboutUs />} />
          <Route path="/shipping-policy" exact element={<Shippingpolicy />} />
          <Route path="/profile" exact element={<MyAccount />} />
          <Route path="/thankyou" exact element={<ThankYou />} />
          <Route path="/Failure" exact element={<Failure />} />
          <Route path="/Success" exact element={<Success />} />
          <Route path="/multipayment" exact element={<MultiPayment />} />
          <Route path="/payment-status" exact element={<PaymentStatus />} />
          <Route
            path="/order-confirmation"
            exact
            element={<OrderTracking isAfterPayment />}
          />
        </Routes>
        {!isMultiPayment && <Footer />}
      </AuthContext>
    </Router>
  );
};

export default AppRouters;
